import { Partial } from '@40seas/entities/common';
import { PaymentMethod } from './payment-method.entity';

export class UpdatePaymentMethodDto extends Partial(PaymentMethod) {}
